import React from 'react';
import './App.css';
import Lottie from 'react-lottie';
import  animationData from './phone-repair.json'

function App() {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <div className="App">
      <header className="App-header">
      <Lottie options={defaultOptions}
              height={400}
              width={400}
              />
        <span className="font-link">
        Website under construction 🚧..... 
        </span>
        <span className="font-link">
       Coming Soon
        </span>
       
      </header>
    </div>
  );
}

export default App;
